import { SyncAppTypes } from 'shared/types';

function getUniqueRowId(rowData: SyncAppTypes.ModifiedSourceTenant) {
  return rowData.id;
}

export const writebackSettingsUtils = {
  getUniqueRowId,
};
